import type { WithId } from '@octopus-do/octopus-project-core'
import { call, put } from 'redux-saga/effects'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { NestClient } from '@/nest'
import {
  type DashboardActions,
  InternalFolderActions as Internal,
} from '../../actions'

export function* create({
  payload: { workspaceId, folder },
}: ReturnType<typeof DashboardActions.folders.create>) {
  yield put(Internal.add({ workspaceId, folder }))

  const created: WithId = yield call(NestClient.folders.create, workspaceId, {
    title: folder.title,
  })

  sendGtmEvent(GtmTriggerName.DASHBOARD_NEW_FOLDER)

  const localId = folder.id
  yield put(Internal.update({ id: localId, workspaceId, data: created }))
}
